import * as React from 'react';
import { Form, Checkbox, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import './ConnectionReadOnlyCheckbox.less';

type Props = {
    initialValue?: boolean;
};

const ConnectionReadOnlyCheckbox: React.FC<Props> = ({ initialValue }) => (
    <div className="connection-read-only-checkbox-container">
        <Form.Item
            className="connection-read-only-checkbox"
            valuePropName="checked"
            name="isReadOnly"
            initialValue={initialValue ?? false}
        >
            <Checkbox>Read-only</Checkbox>
        </Form.Item>
        <Tooltip title="If this connection retrieves real tables from the database, enable Read-only to prevent accidental changes that could disrupt system functionality.">
            <ExclamationCircleOutlined className="warning-icon" />
        </Tooltip>
    </div>
);

export default ConnectionReadOnlyCheckbox;
